import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { getSampleDetailsSectionUrl } from "../../../util";

const SampleReportGridLink = ({
  data,
  section,
  sampleSourceID,
  relationshipID,
  isExtractedFile,
  icon
}) => {
  const displayCount = data?.event_count !== null && data?.event_count > 0;
  const href = getSampleDetailsSectionUrl(
    section,
    null,
    data.sha1,
    sampleSourceID,
    isExtractedFile && data.relationship_id === 0
      ? relationshipID
      : data.relationship_id
  );

  return (
    <>
      {icon}
      <Link to={href} className="sample-report-grid__link">
        {data.filename}
        {displayCount && (
          <span className="sample-report-grid__count">
            + {data.event_count}
          </span>
        )}
      </Link>
    </>
  );
};

SampleReportGridLink.propTypes = {
  data: PropTypes.shape(),
  section: PropTypes.string,
  sampleSourceID: PropTypes.number,
  relationshipID: PropTypes.number,
  isExtractedFile: PropTypes.bool,
  icon: PropTypes.node
};

export default SampleReportGridLink;
